module.exports = __webpack_public_path__ + "static/media/icon-delete-white.a7c3d61c.svg";